export const SOLVENCY_DECLARATION_STATUSES = {
    draft: 'draft',
    to_be_resubmitted: 'to_be_resubmitted',
    submitted: 'submitted',
    approved: 'approved',
    rejected: 'rejected',
    expired: 'expired',
};
export const FIELDS_STEPS_MAPING = {
    credit_purpose: 1,
    other_obligations_group: 1,
    for_real_estate_credits: 1,
    for_real_estate_credits_amount: 1,
    for_consumer_credits: 1,
    for_consumer_credits_amount: 1,
    for_other_obligations: 1,
    for_other_obligations_amount: 1,
    liability_planning: 1,
    liability_planning_amount: 1,
    number_of_dependents: 1,
    your_living_estate: 1,
    your_living_estate_other: 1,
    income: 2,
    income_source: 2,
    period_of_income: 2,
    income_change: 2,
    income_change_decrease: 2,
    income_change_decrease_amount: 2,
    credit_amount: 3,
    credit_period: 3,
    you_are_beneficial_owner: 3,
    you_are_pep: 3,
    you_are_pep_relation: 3,
    public_duties: 3,
    for_peronal: 3,
    data_correctness_confirmation: 3,
};
export const SOLVENCY_DECLARATION_ERRORS = {
    current_time_not_allowed: 'current_time_not_allowed',
    current_solvency_declaration_not_found: 'current_solvency_declaration_not_found',
    newest_solvency_declaration_rejected: 'newest_solvency_declaration_rejected',
};
export const PEP_FIELD = 'you_are_pep';
